var cov_2fxy8bu2bi = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/Table.tsx",
      hash = "dc539bca1c0627f58d42bc4fd4a53a9d0b2d62a8",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/Table.tsx",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 28
        },
        end: {
          line: 21,
          column: 55
        }
      },
      "1": {
        start: {
          line: 22,
          column: 26
        },
        end: {
          line: 22,
          column: 51
        }
      },
      "2": {
        start: {
          line: 24,
          column: 22
        },
        end: {
          line: 26,
          column: 113
        }
      },
      "3": {
        start: {
          line: 26,
          column: 37
        },
        end: {
          line: 26,
          column: 113
        }
      },
      "4": {
        start: {
          line: 26,
          column: 46
        },
        end: {
          line: 26,
          column: 113
        }
      },
      "5": {
        start: {
          line: 33,
          column: 21
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "6": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 16
        }
      },
      "7": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 53,
          column: 5
        }
      },
      "8": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 46
        }
      },
      "9": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 68,
          column: 5
        }
      },
      "10": {
        start: {
          line: 60,
          column: 23
        },
        end: {
          line: 65,
          column: 8
        }
      },
      "11": {
        start: {
          line: 61,
          column: 22
        },
        end: {
          line: 61,
          column: 32
        }
      },
      "12": {
        start: {
          line: 62,
          column: 8
        },
        end: {
          line: 64,
          column: 10
        }
      },
      "13": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 34
        }
      },
      "14": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 37
        }
      },
      "15": {
        start: {
          line: 72,
          column: 36
        },
        end: {
          line: 72,
          column: 46
        }
      },
      "16": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 43
        }
      },
      "17": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 42
        }
      },
      "18": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 77,
          column: 5
        }
      },
      "19": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 28
        }
      },
      "20": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 84,
          column: 5
        }
      },
      "21": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 39
        }
      },
      "22": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 33
        }
      },
      "23": {
        start: {
          line: 88,
          column: 66
        },
        end: {
          line: 88,
          column: 76
        }
      },
      "24": {
        start: {
          line: 89,
          column: 23
        },
        end: {
          line: 89,
          column: 34
        }
      },
      "25": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 86
        }
      },
      "26": {
        start: {
          line: 90,
          column: 69
        },
        end: {
          line: 90,
          column: 86
        }
      },
      "27": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 43
        }
      },
      "28": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 49
        }
      },
      "29": {
        start: {
          line: 99,
          column: 28
        },
        end: {
          line: 99,
          column: 38
        }
      },
      "30": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 19
        }
      },
      "31": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 42
        }
      },
      "32": {
        start: {
          line: 101,
          column: 27
        },
        end: {
          line: 101,
          column: 42
        }
      },
      "33": {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 124,
          column: 18
        }
      },
      "34": {
        start: {
          line: 126,
          column: 40
        },
        end: {
          line: 126,
          column: 50
        }
      },
      "35": {
        start: {
          line: 128,
          column: 22
        },
        end: {
          line: 143,
          column: 5
        }
      },
      "36": {
        start: {
          line: 145,
          column: 18
        },
        end: {
          line: 158,
          column: 5
        }
      },
      "37": {
        start: {
          line: 160,
          column: 20
        },
        end: {
          line: 160,
          column: 61
        }
      },
      "38": {
        start: {
          line: 161,
          column: 24
        },
        end: {
          line: 161,
          column: 41
        }
      },
      "39": {
        start: {
          line: 162,
          column: 27
        },
        end: {
          line: 162,
          column: 80
        }
      },
      "40": {
        start: {
          line: 163,
          column: 27
        },
        end: {
          line: 163,
          column: 76
        }
      },
      "41": {
        start: {
          line: 164,
          column: 24
        },
        end: {
          line: 164,
          column: 69
        }
      },
      "42": {
        start: {
          line: 165,
          column: 21
        },
        end: {
          line: 165,
          column: 45
        }
      },
      "43": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 166,
          column: 40
        }
      },
      "44": {
        start: {
          line: 166,
          column: 16
        },
        end: {
          line: 166,
          column: 40
        }
      },
      "45": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 167,
          column: 65
        }
      },
      "46": {
        start: {
          line: 167,
          column: 41
        },
        end: {
          line: 167,
          column: 65
        }
      },
      "47": {
        start: {
          line: 169,
          column: 4
        },
        end: {
          line: 184,
          column: 5
        }
      },
      "48": {
        start: {
          line: 188,
          column: 38
        },
        end: {
          line: 188,
          column: 95
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 24,
            column: 22
          },
          end: {
            line: 24,
            column: 23
          }
        },
        loc: {
          start: {
            line: 26,
            column: 37
          },
          end: {
            line: 26,
            column: 113
          }
        },
        line: 26
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 26,
            column: 37
          },
          end: {
            line: 26,
            column: 38
          }
        },
        loc: {
          start: {
            line: 26,
            column: 46
          },
          end: {
            line: 26,
            column: 113
          }
        },
        line: 26
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 3
          }
        },
        loc: {
          start: {
            line: 47,
            column: 56
          },
          end: {
            line: 56,
            column: 3
          }
        },
        line: 47
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 58,
            column: 3
          }
        },
        loc: {
          start: {
            line: 58,
            column: 22
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 58
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 60,
            column: 48
          },
          end: {
            line: 60,
            column: 49
          }
        },
        loc: {
          start: {
            line: 60,
            column: 59
          },
          end: {
            line: 65,
            column: 7
          }
        },
        line: 60
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        loc: {
          start: {
            line: 71,
            column: 66
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 71
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        },
        loc: {
          start: {
            line: 80,
            column: 25
          },
          end: {
            line: 85,
            column: 3
          }
        },
        line: 80
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        },
        loc: {
          start: {
            line: 87,
            column: 18
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 87
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 94,
            column: 3
          }
        },
        loc: {
          start: {
            line: 94,
            column: 20
          },
          end: {
            line: 96,
            column: 3
          }
        },
        line: 94
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 98,
            column: 2
          },
          end: {
            line: 98,
            column: 3
          }
        },
        loc: {
          start: {
            line: 98,
            column: 32
          },
          end: {
            line: 102,
            column: 3
          }
        },
        line: 98
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 104,
            column: 2
          },
          end: {
            line: 104,
            column: 3
          }
        },
        loc: {
          start: {
            line: 104,
            column: 11
          },
          end: {
            line: 185,
            column: 3
          }
        },
        line: 104
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 90
          },
          end: {
            line: 26,
            column: 109
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 26,
            column: 104
          },
          end: {
            line: 26,
            column: 105
          }
        }, {
          start: {
            line: 26,
            column: 108
          },
          end: {
            line: 26,
            column: 109
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }, {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }],
        line: 59
      },
      "2": {
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 25
          }
        }, {
          start: {
            line: 59,
            column: 29
          },
          end: {
            line: 59,
            column: 39
          }
        }, {
          start: {
            line: 59,
            column: 43
          },
          end: {
            line: 59,
            column: 70
          }
        }],
        line: 59
      },
      "3": {
        loc: {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        }, {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        }],
        line: 75
      },
      "4": {
        loc: {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 20
          }
        }, {
          start: {
            line: 75,
            column: 24
          },
          end: {
            line: 75,
            column: 57
          }
        }],
        line: 75
      },
      "5": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }],
        line: 81
      },
      "6": {
        loc: {
          start: {
            line: 88,
            column: 12
          },
          end: {
            line: 88,
            column: 48
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 88,
            column: 25
          },
          end: {
            line: 88,
            column: 48
          }
        }],
        line: 88
      },
      "7": {
        loc: {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 86
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 86
          }
        }, {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 86
          }
        }],
        line: 90
      },
      "8": {
        loc: {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 90,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 90,
            column: 23
          }
        }, {
          start: {
            line: 90,
            column: 27
          },
          end: {
            line: 90,
            column: 50
          }
        }, {
          start: {
            line: 90,
            column: 54
          },
          end: {
            line: 90,
            column: 67
          }
        }],
        line: 90
      },
      "9": {
        loc: {
          start: {
            line: 95,
            column: 11
          },
          end: {
            line: 95,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 95,
            column: 11
          },
          end: {
            line: 95,
            column: 28
          }
        }, {
          start: {
            line: 95,
            column: 32
          },
          end: {
            line: 95,
            column: 49
          }
        }],
        line: 95
      },
      "10": {
        loc: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 42
          }
        }, {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 42
          }
        }],
        line: 101
      },
      "11": {
        loc: {
          start: {
            line: 101,
            column: 8
          },
          end: {
            line: 101,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 101,
            column: 8
          },
          end: {
            line: 101,
            column: 10
          }
        }, {
          start: {
            line: 101,
            column: 14
          },
          end: {
            line: 101,
            column: 25
          }
        }],
        line: 101
      },
      "12": {
        loc: {
          start: {
            line: 132,
            column: 8
          },
          end: {
            line: 132,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 8
          },
          end: {
            line: 132,
            column: 13
          }
        }, {
          start: {
            line: 132,
            column: 17
          },
          end: {
            line: 132,
            column: 24
          }
        }],
        line: 132
      },
      "13": {
        loc: {
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 133,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 133,
            column: 16
          }
        }, {
          start: {
            line: 133,
            column: 20
          },
          end: {
            line: 133,
            column: 30
          }
        }],
        line: 133
      },
      "14": {
        loc: {
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 134,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 134,
            column: 13
          }
        }, {
          start: {
            line: 134,
            column: 17
          },
          end: {
            line: 134,
            column: 24
          }
        }],
        line: 134
      },
      "15": {
        loc: {
          start: {
            line: 135,
            column: 8
          },
          end: {
            line: 135,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 135,
            column: 8
          },
          end: {
            line: 135,
            column: 22
          }
        }, {
          start: {
            line: 135,
            column: 26
          },
          end: {
            line: 135,
            column: 38
          }
        }],
        line: 135
      },
      "16": {
        loc: {
          start: {
            line: 136,
            column: 8
          },
          end: {
            line: 136,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 136,
            column: 8
          },
          end: {
            line: 136,
            column: 23
          }
        }, {
          start: {
            line: 136,
            column: 27
          },
          end: {
            line: 136,
            column: 40
          }
        }],
        line: 136
      },
      "17": {
        loc: {
          start: {
            line: 138,
            column: 8
          },
          end: {
            line: 138,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 138,
            column: 8
          },
          end: {
            line: 138,
            column: 23
          }
        }, {
          start: {
            line: 138,
            column: 27
          },
          end: {
            line: 138,
            column: 35
          }
        }],
        line: 138
      },
      "18": {
        loc: {
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 139,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 139,
            column: 30
          }
        }, {
          start: {
            line: 139,
            column: 34
          },
          end: {
            line: 139,
            column: 42
          }
        }],
        line: 139
      },
      "19": {
        loc: {
          start: {
            line: 140,
            column: 8
          },
          end: {
            line: 140,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 140,
            column: 8
          },
          end: {
            line: 140,
            column: 15
          }
        }, {
          start: {
            line: 140,
            column: 19
          },
          end: {
            line: 140,
            column: 24
          }
        }],
        line: 140
      },
      "20": {
        loc: {
          start: {
            line: 160,
            column: 20
          },
          end: {
            line: 160,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 160,
            column: 21
          },
          end: {
            line: 160,
            column: 26
          }
        }, {
          start: {
            line: 160,
            column: 30
          },
          end: {
            line: 160,
            column: 47
          }
        }, {
          start: {
            line: 160,
            column: 52
          },
          end: {
            line: 160,
            column: 61
          }
        }],
        line: 160
      },
      "21": {
        loc: {
          start: {
            line: 161,
            column: 24
          },
          end: {
            line: 161,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 161,
            column: 24
          },
          end: {
            line: 161,
            column: 29
          }
        }, {
          start: {
            line: 161,
            column: 33
          },
          end: {
            line: 161,
            column: 41
          }
        }],
        line: 161
      },
      "22": {
        loc: {
          start: {
            line: 162,
            column: 27
          },
          end: {
            line: 162,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 162,
            column: 45
          },
          end: {
            line: 162,
            column: 64
          }
        }, {
          start: {
            line: 162,
            column: 67
          },
          end: {
            line: 162,
            column: 80
          }
        }],
        line: 162
      },
      "23": {
        loc: {
          start: {
            line: 163,
            column: 27
          },
          end: {
            line: 163,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 163,
            column: 45
          },
          end: {
            line: 163,
            column: 62
          }
        }, {
          start: {
            line: 163,
            column: 65
          },
          end: {
            line: 163,
            column: 76
          }
        }],
        line: 163
      },
      "24": {
        loc: {
          start: {
            line: 164,
            column: 24
          },
          end: {
            line: 164,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 164,
            column: 38
          },
          end: {
            line: 164,
            column: 52
          }
        }, {
          start: {
            line: 164,
            column: 55
          },
          end: {
            line: 164,
            column: 69
          }
        }],
        line: 164
      },
      "25": {
        loc: {
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 166,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 166,
            column: 40
          }
        }, {
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 166,
            column: 40
          }
        }],
        line: 166
      },
      "26": {
        loc: {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 167,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 167,
            column: 65
          }
        }, {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 167,
            column: 65
          }
        }],
        line: 167
      },
      "27": {
        loc: {
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 167,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 167,
            column: 19
          }
        }, {
          start: {
            line: 167,
            column: 23
          },
          end: {
            line: 167,
            column: 39
          }
        }],
        line: 167
      },
      "28": {
        loc: {
          start: {
            line: 172,
            column: 9
          },
          end: {
            line: 174,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 172,
            column: 9
          },
          end: {
            line: 172,
            column: 16
          }
        }, {
          start: {
            line: 173,
            column: 10
          },
          end: {
            line: 173,
            column: 116
          }
        }],
        line: 172
      },
      "29": {
        loc: {
          start: {
            line: 173,
            column: 50
          },
          end: {
            line: 173,
            column: 109
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 173,
            column: 81
          },
          end: {
            line: 173,
            column: 99
          }
        }, {
          start: {
            line: 173,
            column: 102
          },
          end: {
            line: 173,
            column: 109
          }
        }],
        line: 173
      },
      "30": {
        loc: {
          start: {
            line: 175,
            column: 9
          },
          end: {
            line: 182,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 175,
            column: 9
          },
          end: {
            line: 175,
            column: 16
          }
        }, {
          start: {
            line: 176,
            column: 10
          },
          end: {
            line: 181,
            column: 16
          }
        }],
        line: 175
      },
      "31": {
        loc: {
          start: {
            line: 178,
            column: 33
          },
          end: {
            line: 178,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 178,
            column: 43
          },
          end: {
            line: 178,
            column: 51
          }
        }, {
          start: {
            line: 178,
            column: 54
          },
          end: {
            line: 178,
            column: 63
          }
        }],
        line: 178
      },
      "32": {
        loc: {
          start: {
            line: 180,
            column: 19
          },
          end: {
            line: 180,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 180,
            column: 19
          },
          end: {
            line: 180,
            column: 24
          }
        }, {
          start: {
            line: 180,
            column: 28
          },
          end: {
            line: 180,
            column: 47
          }
        }],
        line: 180
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _this = this,
    _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/Table.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { isRTL } from '../config';
import { Component } from '../component';
import { getLocale } from '../locale';
import { compose } from '../utils/func';
import { getDirectionClass } from '../utils/classname';
import { tableClass } from './styles';
import fixedAuto from './fixedAuto';
import Datum from '../Datum';
import Spin from '../Spin';
import resizableHOC from './resizable';
import { consumer as hideableConsumer } from '../hoc/hidable';
import SeperateTable from './SeperateTable';
import SimpleTable from './SimpleTable';
import { ROW_HEIGHT_UPDATE_EVENT } from './Tr';
import { RENDER_COL_GROUP_EVENT } from './Tbody';
import select from './select';
var ResizeSeperateTable = (cov_2fxy8bu2bi.s[0]++, resizableHOC(SeperateTable));
var ResizeSimpleTable = (cov_2fxy8bu2bi.s[1]++, resizableHOC(SimpleTable));
cov_2fxy8bu2bi.s[2]++;

var RadioWrapper = function RadioWrapper(Origin) {
  cov_2fxy8bu2bi.f[0]++;
  cov_2fxy8bu2bi.s[3]++;
  return function (props) {
    cov_2fxy8bu2bi.f[1]++;
    cov_2fxy8bu2bi.s[4]++;
    return (
      /*#__PURE__*/
      React.createElement(Origin, Object.assign({}, props, {
        distinct: true,
        limit: props.radio ? (cov_2fxy8bu2bi.b[0][0]++, 1) : (cov_2fxy8bu2bi.b[0][1]++, 0),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 26,
          columnNumber: 47
        }
      }))
    );
  };
};

var DefaultProps = (cov_2fxy8bu2bi.s[5]++, {
  hover: true,
  rowsInView: 20,
  verticalAlign: 'top',
  columns: [],
  size: 'default'
});

var Table =
/*#__PURE__*/
function (_Component) {
  _inherits(Table, _Component);

  var _super = _createSuper2(Table);

  function Table(props) {
    var _this2;

    _classCallCheck(this, Table);

    cov_2fxy8bu2bi.f[2]++;
    cov_2fxy8bu2bi.s[6]++;
    _this2 = _super.call(this, props);
    _this2.table = void 0;
    _this2.visibleObserver = void 0;
    cov_2fxy8bu2bi.s[7]++;
    _this2.state = {
      scrollLeft: 0,
      scrollRight: 0,
      inView: false
    };
    cov_2fxy8bu2bi.s[8]++;
    _this2.bindTable = _this2.bindTable.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      cov_2fxy8bu2bi.f[3]++;
      cov_2fxy8bu2bi.s[9]++;

      if ((cov_2fxy8bu2bi.b[2][0]++, this.props.sticky) && (cov_2fxy8bu2bi.b[2][1]++, this.table) && (cov_2fxy8bu2bi.b[2][2]++, window.IntersectionObserver)) {
        cov_2fxy8bu2bi.b[1][0]++;
        var observer = (cov_2fxy8bu2bi.s[10]++, new IntersectionObserver(function (entries) {
          cov_2fxy8bu2bi.f[4]++;
          var entry = (cov_2fxy8bu2bi.s[11]++, entries[0]);
          cov_2fxy8bu2bi.s[12]++;

          _this3.setState({
            inView: entry.intersectionRatio > 0
          });
        }));
        cov_2fxy8bu2bi.s[13]++;
        observer.observe(this.table);
        cov_2fxy8bu2bi.s[14]++;
        this.visibleObserver = observer;
      } else {
        cov_2fxy8bu2bi.b[1][1]++;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(preProps) {
      cov_2fxy8bu2bi.f[5]++;

      var _ref = (cov_2fxy8bu2bi.s[15]++, this.props),
          datum = _ref.datum,
          treeCheckAll = _ref.treeCheckAll;

      cov_2fxy8bu2bi.s[16]++;
      datum.dispatch(ROW_HEIGHT_UPDATE_EVENT);
      cov_2fxy8bu2bi.s[17]++;
      datum.dispatch(RENDER_COL_GROUP_EVENT);
      cov_2fxy8bu2bi.s[18]++;

      if ((cov_2fxy8bu2bi.b[4][0]++, treeCheckAll) && (cov_2fxy8bu2bi.b[4][1]++, this.props.data !== preProps.data)) {
        cov_2fxy8bu2bi.b[3][0]++;
        cov_2fxy8bu2bi.s[19]++;
        datum.cleanDataCache();
      } else {
        cov_2fxy8bu2bi.b[3][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_2fxy8bu2bi.f[6]++;
      cov_2fxy8bu2bi.s[20]++;

      if (this.visibleObserver) {
        cov_2fxy8bu2bi.b[5][0]++;
        cov_2fxy8bu2bi.s[21]++;
        this.visibleObserver.disconnect();
        cov_2fxy8bu2bi.s[22]++;
        this.visibleObserver = null;
      } else {
        cov_2fxy8bu2bi.b[5][1]++;
      }
    }
  }, {
    key: "getRowsInView",
    value: function getRowsInView() {
      cov_2fxy8bu2bi.f[7]++;

      var _ref2 = (cov_2fxy8bu2bi.s[23]++, this.props),
          _ref2$rowsInView = _ref2.rowsInView,
          rowsInView = _ref2$rowsInView === void 0 ? (cov_2fxy8bu2bi.b[6][0]++, DefaultProps.rowsInView) : _ref2$rowsInView,
          data = _ref2.data,
          fixed = _ref2.fixed;

      var dataLength = (cov_2fxy8bu2bi.s[24]++, data.length);
      cov_2fxy8bu2bi.s[25]++;

      if ((cov_2fxy8bu2bi.b[8][0]++, rowsInView <= 0) || (cov_2fxy8bu2bi.b[8][1]++, rowsInView > dataLength) || (cov_2fxy8bu2bi.b[8][2]++, fixed === 'x')) {
        cov_2fxy8bu2bi.b[7][0]++;
        cov_2fxy8bu2bi.s[26]++;
        return dataLength;
      } else {
        cov_2fxy8bu2bi.b[7][1]++;
      }

      cov_2fxy8bu2bi.s[27]++;
      return parseInt(String(rowsInView), 10);
    }
  }, {
    key: "getShouldSticky",
    value: function getShouldSticky() {
      cov_2fxy8bu2bi.f[8]++;
      cov_2fxy8bu2bi.s[28]++;
      return (cov_2fxy8bu2bi.b[9][0]++, this.state.inView) && (cov_2fxy8bu2bi.b[9][1]++, this.props.sticky);
    }
  }, {
    key: "bindTable",
    value: function bindTable(el) {
      cov_2fxy8bu2bi.f[9]++;

      var _ref3 = (cov_2fxy8bu2bi.s[29]++, this.props),
          bindWrapper = _ref3.bindWrapper;

      cov_2fxy8bu2bi.s[30]++;
      this.table = el;
      cov_2fxy8bu2bi.s[31]++;

      if ((cov_2fxy8bu2bi.b[11][0]++, el) && (cov_2fxy8bu2bi.b[11][1]++, bindWrapper)) {
        cov_2fxy8bu2bi.b[10][0]++;
        cov_2fxy8bu2bi.s[32]++;
        bindWrapper(el);
      } else {
        cov_2fxy8bu2bi.b[10][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_2fxy8bu2bi.f[10]++;

      var _ref4 = (cov_2fxy8bu2bi.s[33]++, this.props),
          striped = _ref4.striped,
          bordered = _ref4.bordered,
          size = _ref4.size,
          hover = _ref4.hover,
          height = _ref4.height,
          columns = _ref4.columns,
          children = _ref4.children,
          empty = _ref4.empty,
          data = _ref4.data,
          style = _ref4.style,
          fixed = _ref4.fixed,
          width = _ref4.width,
          loading = _ref4.loading,
          verticalAlign = _ref4.verticalAlign,
          columnResizable = _ref4.columnResizable,
          events = _ref4.events,
          others = _objectWithoutProperties(_ref4, ["striped", "bordered", "size", "hover", "height", "columns", "children", "empty", "data", "style", "fixed", "width", "loading", "verticalAlign", "columnResizable", "events"]);

      var _ref5 = (cov_2fxy8bu2bi.s[34]++, this.state),
          scrollLeft = _ref5.scrollLeft,
          scrollRight = _ref5.scrollRight;

      var className = (cov_2fxy8bu2bi.s[35]++, classnames(tableClass('_', size, (cov_2fxy8bu2bi.b[12][0]++, hover) && (cov_2fxy8bu2bi.b[12][1]++, 'hover'), (cov_2fxy8bu2bi.b[13][0]++, bordered) && (cov_2fxy8bu2bi.b[13][1]++, 'bordered'), (cov_2fxy8bu2bi.b[14][0]++, fixed) && (cov_2fxy8bu2bi.b[14][1]++, 'fixed'), (cov_2fxy8bu2bi.b[15][0]++, scrollLeft > 0) && (cov_2fxy8bu2bi.b[15][1]++, 'left-float'), (cov_2fxy8bu2bi.b[16][0]++, scrollRight < 0) && (cov_2fxy8bu2bi.b[16][1]++, 'right-float'), "vertical-".concat(verticalAlign), (cov_2fxy8bu2bi.b[17][0]++, columnResizable) && (cov_2fxy8bu2bi.b[17][1]++, 'resize'), (cov_2fxy8bu2bi.b[18][0]++, this.getShouldSticky()) && (cov_2fxy8bu2bi.b[18][1]++, 'sticky'), (cov_2fxy8bu2bi.b[19][0]++, isRTL()) && (cov_2fxy8bu2bi.b[19][1]++, 'rtl')), this.props.className));
      var props = (cov_2fxy8bu2bi.s[36]++, _objectSpread2(_objectSpread2({}, others), {}, {
        children: children,
        fixed: fixed,
        rowsInView: this.getRowsInView(),
        loading: loading,
        height: height,
        width: width,
        data: data,
        columns: columns,
        striped: striped,
        bordered: bordered,
        columnResizable: columnResizable
      }));
      var isEmpty = (cov_2fxy8bu2bi.s[37]++, ((cov_2fxy8bu2bi.b[20][0]++, !data) || (cov_2fxy8bu2bi.b[20][1]++, data.length === 0)) && (cov_2fxy8bu2bi.b[20][2]++, !children));
      var useSeparate = (cov_2fxy8bu2bi.s[38]++, (cov_2fxy8bu2bi.b[21][0]++, fixed) && (cov_2fxy8bu2bi.b[21][1]++, !isEmpty));
      var ResizeSepTable = (cov_2fxy8bu2bi.s[39]++, columnResizable ? (cov_2fxy8bu2bi.b[22][0]++, ResizeSeperateTable) : (cov_2fxy8bu2bi.b[22][1]++, SeperateTable));
      var ResizeSimTable = (cov_2fxy8bu2bi.s[40]++, columnResizable ? (cov_2fxy8bu2bi.b[23][0]++, ResizeSimpleTable) : (cov_2fxy8bu2bi.b[23][1]++, SimpleTable));
      var RenderTable = (cov_2fxy8bu2bi.s[41]++, useSeparate ? (cov_2fxy8bu2bi.b[24][0]++, ResizeSepTable) : (cov_2fxy8bu2bi.b[24][1]++, ResizeSimTable));
      var newStyle = (cov_2fxy8bu2bi.s[42]++, Object.assign({}, style));
      cov_2fxy8bu2bi.s[43]++;

      if (height) {
        cov_2fxy8bu2bi.b[25][0]++;
        cov_2fxy8bu2bi.s[44]++;
        newStyle.height = height;
      } else {
        cov_2fxy8bu2bi.b[25][1]++;
      }

      cov_2fxy8bu2bi.s[45]++;

      if ((cov_2fxy8bu2bi.b[27][0]++, useSeparate) && (cov_2fxy8bu2bi.b[27][1]++, !newStyle.height)) {
        cov_2fxy8bu2bi.b[26][0]++;
        cov_2fxy8bu2bi.s[46]++;
        newStyle.height = '100%';
      } else {
        cov_2fxy8bu2bi.b[26][1]++;
      }

      cov_2fxy8bu2bi.s[47]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: className,
          ref: this.bindTable,
          style: newStyle
        }, events, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 170,
            columnNumber: 7
          }
        }),
        /*#__PURE__*/
        React.createElement(RenderTable, Object.assign({}, props, {
          bordered: bordered,
          sticky: this.getShouldSticky(),
          inView: this.state.inView,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 171,
            columnNumber: 9
          }
        })), (cov_2fxy8bu2bi.b[28][0]++, loading) && (cov_2fxy8bu2bi.b[28][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: tableClass('loading'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 173,
            columnNumber: 11
          }
        }, typeof loading === 'boolean' ? (cov_2fxy8bu2bi.b[29][0]++,
        /*#__PURE__*/
        React.createElement(Spin, {
          size: 40,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 173,
            columnNumber: 82
          }
        })) : (cov_2fxy8bu2bi.b[29][1]++, loading))), (cov_2fxy8bu2bi.b[30][0]++, isEmpty) && (cov_2fxy8bu2bi.b[30][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: tableClass(getDirectionClass('empty')),
          style: {
            visibility: loading ? (cov_2fxy8bu2bi.b[31][0]++, 'hidden') : (cov_2fxy8bu2bi.b[31][1]++, 'visible')
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 176,
            columnNumber: 11
          }
        },
        /*#__PURE__*/
        React.createElement("span", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 180,
            columnNumber: 13
          }
        }, (cov_2fxy8bu2bi.b[32][0]++, empty) || (cov_2fxy8bu2bi.b[32][1]++, getLocale('noData'))))))
      );
    }
  }]);

  return Table;
}(Component);

Table.defaultProps = DefaultProps;
var bindKeys = (cov_2fxy8bu2bi.s[48]++, ['disabled', 'format', 'prediction', 'limit', 'distinct']);
export default compose(RadioWrapper, Datum.hoc({
  bindProps: bindKeys,
  ignoreUndefined: true,
  setValueType: null,
  pure: false
}), fixedAuto, hideableConsumer, select)(Table);